/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventStatusEnum } from './EventStatusEnum';
import {
    EventStatusEnumFromJSON,
    EventStatusEnumFromJSONTyped,
    EventStatusEnumToJSON,
    EventStatusEnumToJSONTyped,
} from './EventStatusEnum';

/**
 * Emission Event serializer with emission records.
 * @export
 * @interface EmissionEventFullRequest
 */
export interface EmissionEventFullRequest {
    /**
     * 
     * @type {number}
     * @memberof EmissionEventFullRequest
     */
    owner: number;
    /**
     * 
     * @type {string}
     * @memberof EmissionEventFullRequest
     */
    mainEvent?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EmissionEventFullRequest
     */
    responsible?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmissionEventFullRequest
     */
    reviewer?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EmissionEventFullRequest
     */
    mainEmissionRecord: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmissionEventFullRequest
     */
    linkedEvents: Array<string>;
    /**
     * 
     * @type {EventStatusEnum}
     * @memberof EmissionEventFullRequest
     */
    eventStatus: EventStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof EmissionEventFullRequest
     */
    extraNotes?: string;
    /**
     * 
     * @type {any}
     * @memberof EmissionEventFullRequest
     */
    formData?: any | null;
}



/**
 * Check if a given object implements the EmissionEventFullRequest interface.
 */
export function instanceOfEmissionEventFullRequest(value: object): value is EmissionEventFullRequest {
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if ((!('mainEmissionRecord' in (value as Record<string, any>)) && !('main_emission_record' in (value as Record<string, any>))) || ((value as Record<string, any>)['mainEmissionRecord'] === undefined && (value as Record<string, any>)['main_emission_record'] === undefined)) return false;
    if ((!('linkedEvents' in (value as Record<string, any>)) && !('linked_events' in (value as Record<string, any>))) || ((value as Record<string, any>)['linkedEvents'] === undefined && (value as Record<string, any>)['linked_events'] === undefined)) return false;
    if ((!('eventStatus' in (value as Record<string, any>)) && !('event_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['eventStatus'] === undefined && (value as Record<string, any>)['event_status'] === undefined)) return false;
    return true;
}

export function EmissionEventFullRequestFromJSON(json: any): EmissionEventFullRequest {
    return EmissionEventFullRequestFromJSONTyped(json, false);
}

export function EmissionEventFullRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionEventFullRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'owner': json['owner'],
        'mainEvent': json['main_event'] === undefined ? undefined : json['main_event'] === null ? null : json['main_event'],
        'responsible': json['responsible'] === undefined ? undefined : json['responsible'] === null ? null : json['responsible'],
        'reviewer': json['reviewer'] === undefined ? undefined : json['reviewer'] === null ? null : json['reviewer'],
        'mainEmissionRecord': json['main_emission_record'],
        'linkedEvents': json['linked_events'],
        'eventStatus': EventStatusEnumFromJSON(json['event_status']),
        'extraNotes': json['extra_notes'] == null ? undefined : json['extra_notes'],
        'formData': json['form_data'] === undefined ? undefined : json['form_data'] === null ? null : json['form_data'],
    };
}

export function EmissionEventFullRequestToJSON(json: any): EmissionEventFullRequest {
    return EmissionEventFullRequestToJSONTyped(json, false);
}

export function EmissionEventFullRequestToJSONTyped(value?: EmissionEventFullRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'main_event': value['mainEvent'],
        'responsible': value['responsible'],
        'reviewer': value['reviewer'],
        'main_emission_record': value['mainEmissionRecord'],
        'linked_events': value['linkedEvents'],
        'event_status': EventStatusEnumToJSON(value['eventStatus']),
        'extra_notes': value['extraNotes'],
        'form_data': value['formData'],
    };
}

